/**
 * Example action that shows a notification
 * This action can be triggered with: window.addEventListener('arc:action:SearchAction')
 */

export const runSearchAction = async (data = {}) => {
    try {
        const {
            message = 'Hello from the event system!',
            type = 'info',
            duration = 3000
        } = data;

        const searchFeatured = document.querySelector('.search-featured');
        const searchData = document.querySelector('.search-data');

        if (!searchFeatured || !searchData) {
            throw new Error('Search elements not found');
        }
        // Hide the featured search section and show the data section
        searchFeatured.style.setProperty('display', 'none', 'important');
        searchData.style.setProperty('display', 'block', 'important');

        return {
            success: true,
            message: 'Notification displayed',
            data: { message, type, duration }
        };

    } catch (error) {
        console.error('Error showing notification:', error);
        return {
            success: false,
            error: error.message
        };
    }
};

export default runSearchAction;
